import { render, staticRenderFns } from "./CategoryOrganizationsFeed.vue?vue&type=template&id=05fd42cb&scoped=true&"
import script from "./CategoryOrganizationsFeed.vue?vue&type=script&lang=js&"
export * from "./CategoryOrganizationsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd42cb",
  null
  
)

export default component.exports